<template>
  <v-app id="food-configurator" class="food-configurator">
    <div>
      <v-content>
        <router-view />
      </v-content>
    </div>
    <OnlineTrackingDialog></OnlineTrackingDialog>
  </v-app>
</template>

<style lang="scss">
@import 'sass/main.scss';
.system-overview {
  @include media-breakpoint-up(lg) {
    padding: 0 rem(24);
  }
  &__wrapper {
    @include gutter(margin-top, lg);
  }
  &__label {
    font-size: $font-size-sm;
  }
  table.system_resume {
    @include gutter(margin-top, xs);
    th {
      @include gutter(padding-left, md);
    }
    th,
    td {
      @extend .u-vertical-align-top;
    }
  }
  img {
    @extend .u-display-block;
    @extend .u-w-100;
    @include gutter(margin-top, lg);
  }
}
.results,
.configurator {
  @include media-breakpoint-up(lg) {
    padding: 0 rem(24);
  }
  &__label {
    @include gutter(margin-top, lg);
    margin-bottom: 0 !important;
  }
  table.choosen-results {
    min-width: 100%;
    th,
    td {
      @extend .u-color--black;
      &:first-child {
        @include media-breakpoint-down(md) {
          width: 60%;
        }
        @include media-breakpoint-up(md) {
          width: 45%;
        }
      }
      &:last-child {
        text-align: right !important;
        padding-right: 0 !important;
      }
    }
    th {
      padding: rem(6) rem(12);
      border-bottom: rem(2) solid $color-s400;
    }
    td {
      padding: rem(12);
      border-bottom: rem(1) solid $color-s200;
      &:last-child {
        padding-right: rem(18);
      }
    }
    th:first-child,
    td:first-child  {
      padding-left: 0;
    }
  }
}
.configurator {
  &__label {
    font-size: $font-size-base;
    font-weight: $font-weight-bold;
  }
}
.results {
  &__label {
    font-size: $font-size-sm;
  }
}
</style>

<script>
import config from "./configuration.json";
import OnlineTrackingDialog from "./components/OnlineTrackingDialog";
import TrackingHelper from "./helpers/TrackingHelper";

export default {
  name: "App",
  watch: {
    "$store.getters.onlineTrackingEnabled": function() {
      location.reload();
    },
  },
  components: {
    OnlineTrackingDialog,
  },
  data() {
    return {
      analyticsDataLayer: {
        app_id: "com.schott.corporate.pwa.fdc",
        app_name: "Food Display Configurator",
        name: "Configuration",
        screen_name: "Configuration",
        uri: "/",
        pageType: "configuration",
        pageTags: ["configuration", "fooddisplay"],
        targetGroup: "customers",
        businessUnit: "F",
        websiteBusiness: "products",
        branded: "unbranded",
        stage: config.stage,
      },
      stage: config.stage,
      onlineStatus: "online",
      onlineSlot: "online",
      offlineSlot: "offline",
    };
  },
  mounted() {
    let script = document.createElement('script');
    script.setAttribute('src', './js/iframeResizer.contentWindow.min.js');
    document.body.appendChild(script);
  },

  created() {
    this.showUserDialog = false;
    if (this.$store.getters.onlineTrackingEnabled) {
      this.configurationCount();
      this.trackUserContext();
      TrackingHelper.initialPageview();
      TrackingHelper.initTracking();
    }
  },
  methods: {
    detactOnlineStatus(e) {
      this.onlineStatus = e ? "online" : "offline";
    },
    configurationCount: async function() {
      /* eslint-disable no-console */
      console.log("configuration count function");
      let dl = this.analyticsDataLayer;
      dl["event_category"] = "click";
      dl["event_label"] = "Button Click / Configuration";
      this.$parent.$appInsights.trackEvent(dl.event_label, dl);
      this.$parent.$appInsights.flush();
    },
    /**
     * Track user context when user session exists
     */
    trackUserContext: function() {
      /* eslint-disable no-console */
      console.log("Track user context function");
      let dl = this.analyticsDataLayer;
      dl["event_category"] = "screenview";
      dl["event_label"] = "Screen View / " + this.analyticsDataLayer.name;
      this.$parent.$appInsights.trackEvent(dl.event_label, dl);
      this.$parent.$appInsights.flush();
    },
  },
};
</script>
